import styled from 'styled-components';
import { headingFont } from '@/styles/mixins';

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[3]};
  flex-wrap: wrap;
  margin-bottom: ${({ theme }) => theme.spacing[5]};

  @media (max-width: 767.98px) {
    gap: ${({ theme }) => theme.spacing[2]};
  }
`;

export const ToolbarSpacer = styled.div`
  flex: 1;

  @media (max-width: 767.98px) {
    width: 100%;
    flex-basis: 100%;
  }
`;

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  flex-wrap: wrap;
`;

export const Section = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing[8]};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitle = styled.h2`
  ${headingFont}
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  margin: 0 0 ${({ theme }) => theme.spacing[4]};
`;

export const SectionDescription = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0 0 ${({ theme }) => theme.spacing[4]};
  max-width: 60ch;
  line-height: ${({ theme }) => theme.lineHeights.normal};
`;
